/**
 * Reorder visible KPI tiles. Unfavorable uses actual vs the selected plan (same as RYG).
 */

import type { KpiTile, TileSort } from './types';

const COLOR_RANK: Record<string, number> = { RED: 0, YELLOW: 1, GREEN: 2 };

export function sortTiles(tiles: KpiTile[], sort: TileSort, selectedIds: string[]): KpiTile[] {
  const copy = [...tiles];
  if (sort === 'default') {
    const order = new Map(selectedIds.map((id, index) => [id, index]));
    copy.sort((left, right) => (order.get(left.kpiId) ?? 9999) - (order.get(right.kpiId) ?? 9999));
    return copy;
  }
  if (sort === 'name') {
    copy.sort((left, right) => left.kpiName.localeCompare(right.kpiName, undefined, { sensitivity: 'base' }));
    return copy;
  }
  copy.sort((left, right) => {
    const leftPace = left.pace;
    const rightPace = right.pace;
    const leftRanked = leftPace !== null && leftPace !== undefined;
    const rightRanked = rightPace !== null && rightPace !== undefined;
    if (leftRanked !== rightRanked) return leftRanked ? -1 : 1;
    if (leftRanked && rightRanked && leftPace !== rightPace) return leftPace - rightPace;
    const color = (COLOR_RANK[left.color || ''] ?? 9) - (COLOR_RANK[right.color || ''] ?? 9);
    if (color !== 0) return color;
    return left.kpiName.localeCompare(right.kpiName, undefined, { sensitivity: 'base' });
  });
  return copy;
}
